import { SET, RESET_STATE } from "@/stores/CommumActionTypes";
import {
	SET_SHOW_STEPPER,
	SET_SELECTED_SIGNAL,
	SET_SELECTED_ASSETS,
	SET_LIMIT_AND_NOTIFICATIONS,
	SET_CONFIGURATOR_VIEW,
	SET_FREQUENCY_LIMIT_MODELS,
	SET_UPDATE_RESULTS,
	SET_LIMITS_DISABLE,
	RESET_UPDATE_RESULTS,
	SET_FEEDBACK_MESSAGE,
	SET_LOADER_ON,
	SET_LOADER_OFF,
	SET_TURBINE_PARTIAL_ERROR,
	PUSH_FREQUENCY_LIMIT_MODEL
} from "./LimitConfiguratorActionsType";
import FrequencyTrendLimitConfigurationService from "../../service/FrequencyTrendLimitConfigurationService";

const actions = {
	/**
   * Define se o stepper deve ser exibido e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {boolean} show - Indica se o stepper deve ser mostrado ou não.
   */
	[SET_SHOW_STEPPER]({ commit }, show)
	{
		commit(SET_SHOW_STEPPER, show);
	},

	/**
   * Define a view atual do configurador e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {string} view - A view que será configurada.
   */
	[SET_CONFIGURATOR_VIEW]({ commit }, view)
	{
		commit(SET_CONFIGURATOR_VIEW, view);
	},

	/**
   * Define os sinais selecionados e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Array} signals - Lista de sinais.
   */
	[SET]: ({ commit }, signals) =>
	{
		commit(SET, signals);
	},

	/**
   * Define os ativos selecionados e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Array} selectedAssets - Lista de ativos selecionados.
   */
	[SET_SELECTED_ASSETS]: ({ commit }, selectedAssets) =>
	{
		commit(SET_SELECTED_ASSETS, selectedAssets);
	},

	/**
   * Define o sinal selecionado e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Object} selectedSignal - O sinal selecionado.
   */
	[SET_SELECTED_SIGNAL]: ({ commit }, selectedSignal) =>
	{
		commit(SET_SELECTED_SIGNAL, selectedSignal);
	},

	/**
   * Define os limites e as notificações e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Object} settings - Configurações de limites e notificações.
   */
	[SET_LIMIT_AND_NOTIFICATIONS]: ({ commit }, settings) =>
	{
		commit(SET_LIMIT_AND_NOTIFICATIONS, settings);
	},

	/**
   * Define os modelos de limite de frequência e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Array} models - Modelos de limite de frequência.
   */
	[SET_FREQUENCY_LIMIT_MODELS]: ({ commit }, models) =>
	{
		commit(SET_FREQUENCY_LIMIT_MODELS, models);
	},

	/**
   * Define os resultados da atualização e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {Array} results - Resultados da atualização.
   */
	[SET_UPDATE_RESULTS]: ({ commit }, results) =>
	{
		const feedbackMessage = FrequencyTrendLimitConfigurationService.GetFeedbackMessage(results);
		commit(SET_FEEDBACK_MESSAGE, feedbackMessage);

		const turbinePartialError = FrequencyTrendLimitConfigurationService.GetTurbinesPartialErrors(results);
		commit(SET_TURBINE_PARTIAL_ERROR, turbinePartialError);

		commit(SET_UPDATE_RESULTS, results);
	},

	/**
   * Reseta state dos resultados da atualização.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[RESET_UPDATE_RESULTS]: ({ commit }) =>
	{
		commit(RESET_UPDATE_RESULTS);
	},

	/**
   * Define os limites que estão desabilitados e guarda no state.
   *
   * @param {Object} context - O contexto Vuex.
   * @param {boolean} bool - Indica se os limites estão desabilitados.
   */
	[SET_LIMITS_DISABLE]: ({ commit }, bool) =>
	{
		commit(SET_LIMITS_DISABLE, bool);
	},

	/**
   * Reseta o state desse modulo.
   *
   * @param {Object} context - O contexto Vuex.
   */
	[RESET_STATE]: ({ commit }) =>
	{
		commit(RESET_STATE);
	},

	/**
	 * Ativa o estado de carregamento do configurador.
	 * 
	 * @param {Object} context - O contexto Vuex para acessar as mutações.
	 */
	[SET_LOADER_ON]: ({ commit }) =>
	{
		commit(SET_LOADER_ON);
	},

	/**
	 * Desativa o estado de carregamento do configurador.
	 * 
	 * @param {Object} context - O contexto Vuex para acessar as mutações.
	 */
	[SET_LOADER_OFF]: ({ commit }) =>
	{
		commit(SET_LOADER_OFF);
	},

	/**
	 * Concatena um model no array de models.
	 * @param {Array} models - Modelos de limite de frequência.
	 */
	[PUSH_FREQUENCY_LIMIT_MODEL]: ({ commit }, model) =>
	{
		commit(PUSH_FREQUENCY_LIMIT_MODEL, model);
	}
};

export default { actions };
